export default __webpack_public_path__ + "static/media/girlSitting.ab982f3c.svg";